module.exports = __webpack_public_path__ + "img/joseph.bb5cba3d.png";